var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('Page',{staticClass:"activations-emails-page",attrs:{"title":_vm.title,"config":{
    needsWidget: true,
    isEmptyState: _vm.emptyState,
    loadPageEmptyState: true,
    loading: _vm.loading,
    needsActivedRewards: true,
    needsActivedBilling: _vm.isBillingModuleV4
  }}},[_c('div',{staticClass:"activations-emails-page__content"},[_c('div',{staticClass:"activations-emails-page__group"},[_c('IntegrationsActivationEmailsList',{attrs:{"showTitle":false},on:{"changedEmptyState":_vm.changeEmptyState,"setLoading":function($event){_vm.loading = $event}}})],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }